module.exports = __webpack_public_path__ + "img/msg.6bf10738.png";